var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Exclude, Expose, Type, Transform } from "class-transformer";
import moment from "moment";
export var PlanType;
(function (PlanType) {
    PlanType["FREE"] = "free";
    PlanType["SHOPLINK"] = "shop";
    PlanType["CUSTOM"] = "custom";
    PlanType["PLAN"] = "plan"; // plan and solo are the same
})(PlanType || (PlanType = {}));
export var BillingCycle;
(function (BillingCycle) {
    BillingCycle["MONTH"] = "month";
    BillingCycle["YEAR"] = "year";
})(BillingCycle || (BillingCycle = {}));
export var FreePlanName;
(function (FreePlanName) {
    FreePlanName["OLD"] = "free";
    FreePlanName["NEW"] = "PERSONAL";
})(FreePlanName || (FreePlanName = {}));
let PlanDTO = class PlanDTO {
    get group() {
        if (this.basePlan) {
            return this.basePlan.name.replace('YEARLY', '').trim();
        }
        return this.name.replace('YEARLY', '').trim();
    }
    isFree() {
        return this.type == PlanType.FREE;
    }
    isAnnual() {
        return this.billingCycle === BillingCycle.YEAR;
    }
    isCustom() {
        return this.type === PlanType.CUSTOM;
    }
    isNewPlan() {
        return this.setLimit > 0 || this.name === FreePlanName.NEW;
    }
    isNewPaidLimitedUploadPlan() {
        return this.isNewPlan() && this.isCustom() && (this.postLimit > 0 || this.storyLimit > 0);
    }
    isPersonalPlan() {
        return this.name === FreePlanName.NEW;
    }
    get isExpired() {
        return this.expiredAt < moment().utc();
    }
};
__decorate([
    Expose()
], PlanDTO.prototype, "id", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "name", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "billingCycle", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "price", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "postLimit", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "memberLimit", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "accountLimit", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "commentLimit", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "period", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "nextPeriod", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "metricsDays", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "analyticsDays", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "type", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "storyLimit", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "uploadsRemain", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "storyUploadsRemain", void 0);
__decorate([
    Expose(),
    Type(() => PlanDTO)
], PlanDTO.prototype, "basePlan", void 0);
__decorate([
    Expose(),
    Transform(({ value }) => (value ? moment.utc(value) : null), {
        toClassOnly: true
    })
], PlanDTO.prototype, "expiredAt", void 0);
__decorate([
    Expose(),
    Transform(({ value }) => (value ? moment.utc(value) : null), {
        toClassOnly: true
    })
], PlanDTO.prototype, "activatedAt", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "isApple", void 0);
__decorate([
    Expose()
], PlanDTO.prototype, "setLimit", void 0);
PlanDTO = __decorate([
    Exclude()
], PlanDTO);
export { PlanDTO };
//# sourceMappingURL=plan.dto.js.map
